export const convertToCamelCase = <T>(obj: any): T => {
  try {
    if (Array.isArray(obj)) {
      return obj.map((item) => convertToCamelCase(item)) as T;
    }
  
    if (obj !== null && typeof obj === "object" && !(obj instanceof Date)) {
      return Object.keys(obj).reduce((acc, key) => {
        const camelKey = key.replace(/_([a-z])/g, (_, letter) =>
          letter.toUpperCase()
        );
        (acc as any)[camelKey] = convertToCamelCase(obj[key]);
        return acc;
      }, {} as T);
    }
  
    return obj as T;
  } catch (error) {
    console.error("Error in convertToCamelCase:", error);
    return obj as T;
  }
};

export const convertToSnakeCase = <T>(
  obj: any,
  excludeKeys: string[] = []
): T => {
  try {
    if (Array.isArray(obj)) {
      return obj.map((item) => convertToSnakeCase(item, excludeKeys)) as T;
    }
  
    if (obj !== null && typeof obj === "object" && !(obj instanceof Date)) {
      return Object.keys(obj).reduce((acc, key) => {
        if (excludeKeys.includes(key)) {
          (acc as any)[key] = obj[key];
        } else {
          const snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
          (acc as any)[snakeKey] = convertToSnakeCase(obj[key], excludeKeys);
        }
        return acc;
      }, {} as T);
    }
  
    return obj as T;
  } catch (error) {
    console.error("Error in convertToSnakeCase:", error);
    return obj as T;
  }
};

export const stringToSnakeCase = (str: string): string =>{
  try {
    return str.replace(/([A-Z])/g, "_$1").toLowerCase();
  } catch (error) {
    console.error("Error in stringToSnakeCase:", error);
    return '';
  }
}
export const stringToCamelCase = (str: string): string =>
  str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase());

export const formatToTwoDecimals=( number:number )=> {
  try {
    return Number(number).toFixed(2);
  } catch (error) {
    console.error("Error in formatToTwoDecimals:", error);
    return number.toString();
  }
}
